import React, { useCallback } from 'react';
import { achievements } from '../utils/achievements';
import { bookmarkLink, getAchievementLevel } from '../utils/functions';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../firebaseConfig';

export const useUserAchievements = (showNotification, t) => {
  const checkAchievements = useCallback(
    (userProgress, isManual) => {
      achievements.forEach((achievement) => {
        if (!userProgress.achievementsUnlocked.includes(achievement.id)) {
          let isAchieved = false;

          switch (achievement.category) {
            case 'book_completion':
              if (userProgress.booksCompleted >= achievement.threshold) {
                isAchieved = true;
              }
              break;
            case 'reading_streak':
              if (userProgress.currentStreak >= achievement.threshold) {
                isAchieved = true;
              }
              break;
            case 'daily_reading':
              if (userProgress.longestSession >= achievement.threshold) {
                isAchieved = isManual ? false : true;
              }
              break;
            case 'pages_read':
              if (userProgress.pagesRead >= achievement.threshold) {
                isAchieved = true;
              }
              break;
            case 'time_read':
              if (userProgress.timeRead >= achievement.threshold) {
                isAchieved = true;
              }
              break;
            case 'sessions':
              if (userProgress.sessions >= achievement.threshold) {
                isAchieved = true;
              }
              break;
            default:
              isAchieved = false;
              break;
          }

          if (isAchieved) {
            userProgress.achievementsUnlocked.push(achievement.id);
            userProgress.achievementsHistory.push({
              id: achievement.id,
              dateUnlocked: new Date().toISOString().split('T')[0], // Store the date as YYYY-MM-DD
            });
            showNotification(achievementBadge(achievement));
            logEvent(analytics, 'achievement_unlocked', {
              achievement: achievement.name,
            });
          }
        }
      });
    },
    [showNotification, t],
  );

  const achievementBadge = useCallback(
    (achievement) => {
      return [
        <div key="title" style={{ marginBottom: '.5rem' }}>
          {t.achievementunlocked}
        </div>,
        <div key="badge" className="notification-badge-wrapper">
          <div
            className={`achievement-item unlocked ${getAchievementLevel(achievement.level)}`}
          >
            <img
              src={bookmarkLink(achievement.level)}
              alt={achievement.name}
              height={64}
              width={64}
              className="achievement-icon"
            />
            <div className="achievement-number">
              {achievement.displayNumber.toLocaleString()}
            </div>
          </div>
          <div className="flex-col">
            <div className="fs-m">{t.trophies[achievement.locale].name}</div>
            <div className="fs-s">{t.trophies[achievement.locale].desc}</div>
          </div>
        </div>,
      ];
    },
    [t],
  );

  return { checkAchievements };
};
